import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import ReactDOM from 'react-dom';

import Modal from 'components/GeneralComponents/Modal';
import Confirm from './Confirm';
import ConfirmStep2 from './ConfirmStep2';
import ConfirmOperation from './ConfirmOperation';
import SearchDialogue from './SearchDialogue';
import constants from '../../constants';
import './Header.scss';
import styled from './styled';
import text from 'strings/text';
import "stylesheets/fonts.scss";

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state ={
      searchTerm: '',
      locInfo: '',
      openActionMenu: false,
      openOperationMenu: false,
      openSortMenu: false,
      openFilterMenu: false,
      showConfirm: false,
      showConfirmOperation: false,
      selectedAction: null,
      showConfirmStep2: false,
      addOperation: false,
      dropdownPos: null,
      actionMenuPos: null,
      selectedSort: null,
      ascending: true,
      showFilterDept: false,
      showFilterEmail: false,
      openSearchWin: false,
      selectedFilter: null,
      selectedDept: null,
      selectedEmail: null,
      selectedEmployeeId: null,
      selectedGroup: null,
      selectedJobTitle: null,
      selectedSkill: null,
      showFilterEmployeeId: false,
      showFilterGroup: false,
      showFilterJobTitle: false,
      showFilterSkill: false,
    };

    this.messages = defineMessages({
      placeholder: {
        id: 'Header.placeholder',
        defaultMessage: 'Search',
      },
    });

    this.openRef = React.createRef();
    this.actionRef = React.createRef();
    this.addRef = React.createRef();
    this.removeRef = React.createRef();
    this.operationRef = React.createRef();
    this.sortRef = React.createRef();
    this.sortWinRef = React.createRef();
    this.filterWinRef = React.createRef();
    this.filterRef = React.createRef();
    this.deptRef = React.createRef();
    this.deptWinRef = React.createRef();
    this.emailRef = React.createRef();
    this.employeeIdRef = React.createRef();

    this._isMounted = false;

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const { requestedOperation, notifySearchTermChanged, notifySortTypeChanged, } = this.props;
    const { searchTerm} = this.props;
    const { sortTypes, } = constants;

    this._isMounted = true;
    notifySearchTermChanged(searchTerm);
    if(requestedOperation && requestedOperation.length > 0) {
      this.setState({showConfirmOperation: true});
    }
    const userRole = (<FormattedMessage
      id="Header.userAccess"
      defaultMessage="User Access"
    />);

    const itemUserRole = {name: sortTypes.USER_ROLE, body: userRole};
    this.setState({selectedSort: itemUserRole});
    notifySortTypeChanged(itemUserRole);

    document.addEventListener("mousedown", this.handleClickOutside);

  }

 componentDidUpdate(prevProps, prevState) {
  const { requestedOperation, selectedUsers } = this.props;
  const {
    openActionMenu, openOperationMenu, addOperation, 
    openSortMenu, openFilterMenu, showFilterDept
  } = this.state;

  // Utility for calculating dropdown position
  const getDropdownPosition = (ref, offset = 0) => {
    if (ref?.current) {
      const rect = ReactDOM.findDOMNode(ref.current)?.getBoundingClientRect();
      if (rect) {
        return {
          top: `${rect.y + rect.height + offset}px`,
          left: `${rect.x}px`
        };
      }
    }
    return { top: '400px', left: '20px' };
  };

  // Handle requested operation change
  if (prevProps.requestedOperation !== requestedOperation && requestedOperation?.length > 0) {
    this.setState({ showConfirmOperation: true });
  }

  // Handle selected users clearing
  if (prevProps.selectedUsers !== selectedUsers &&
      prevProps.selectedUsers?.length > 0 &&
      selectedUsers?.length === 0) {
      this.resetToDefaultState();
  }

  // Map of dropdown states to their associated refs and dimensions
  const dropdownConfigs = [
    {
      changed: prevState.openActionMenu !== openActionMenu && openActionMenu,
      ref: this.openRef,
      dimensions: { width: '200px', height: '100px' },
      stateKey: 'actionMenuPos',
    },
    {
      changed: prevState.openOperationMenu !== openOperationMenu,
      ref: addOperation ? this.addRef : this.removeRef,
      dimensions: { width: '100px', height: '100px' },
      stateKey: 'dropdownPos',
      offset: 15
    },
    {
      changed: prevState.openSortMenu !== openSortMenu && openSortMenu,
      ref: this.sortRef,
      dimensions: { width: '400px', height: '128px' },
      stateKey: 'dropdownPos'
    },
    {
      changed: prevState.openFilterMenu !== openFilterMenu && openFilterMenu,
      ref: this.filterRef,
      dimensions: { width: '200px', height: '128px' },
      stateKey: 'dropdownPos'
    },
    {
      changed: prevState.showFilterDept !== showFilterDept && showFilterDept,
      ref: this.deptRef,
      dimensions: { width: '200px', height: '128px' },
      stateKey: 'dropdownPos',
      offset: 5
    }
  ];

  dropdownConfigs.forEach(({ changed, ref, dimensions, stateKey, offset = 0 }) => {
    if (changed) {
      const { top, left } = getDropdownPosition(ref, offset);
      this.setState({
        [stateKey]: {
          top,
          left,
          ...dimensions
        }
      });
    }
  });
}

 resetToDefaultState = () => {
    this.setState({
      selectedFilter: null,
      selectedDept: null,
      selectedEmail: null,
      selectedEmployeeId: null,
      selectedGroup: null,
      selectedJobTitle: null,
      selectedSkill: null,
      showFilterDept: false,
      showFilterEmail: false,
      showFilterEmployeeId: false,
      showFilterGroup: false,
      showFilterJobTitle: false,
      showFilterSkill: false,
    });
  }


  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { openActionMenu, openOperationMenu, openSortMenu, openFilterMenu, } = this.state;
    const { notifyDropDownOpened, } = this.props;

    if(this.openRef && this.openRef.current && !this.openRef.current.contains(event.target)) {
      if(this.actionRef && this.actionRef.current && !this.actionRef.current.contains(event.target)) {
        if(openActionMenu) {
          this.setState({openActionMenu: false});
          notifyDropDownOpened(false);
        }
      }
    }

    if(this.addRef && this.addRef.current && !this.addRef.current.contains(event.target)) {
      if(this.operationRef && this.operationRef.current && !this.operationRef.current.contains(event.target)) {
        if(openOperationMenu) {
          this.setState({openOperationMenu: false});
          notifyDropDownOpened(false);
        }
      }
    }

    if(this.removeRef && this.removeRef.current && !this.removeRef.current.contains(event.target)) {
      if(this.operationRef && this.operationRef.current && !this.operationRef.current.contains(event.target)) {
        if(openOperationMenu) {
          this.setState({openOperationMenu: false});
          notifyDropDownOpened(false);
        }
      }
    }

    if(this.sortRef && this.sortRef.current && !this.sortRef.current.contains(event.target)) {
      if(this.sortWinRef && this.sortWinRef.current && !this.sortWinRef.current.contains(event.target)) {
        if(openSortMenu) {
          this.setState({openSortMenu: false});
          notifyDropDownOpened(false);
        }
      }
    }

    if(this.filterRef && this.filterRef.current && !this.filterRef.current.contains(event.target)) {
      if(this.filterWinRef && this.filterWinRef.current && !this.filterWinRef.current.contains(event.target)) {
        if(openFilterMenu) {
          this.setState({openFilterMenu: false});
          notifyDropDownOpened(false);
        }
      }
    }
  }

  handleKeyPress = (event) => {
    const { notifySearchTermChanged, } = this.props;
    const { searchTerm, } = this.state;

    if(event.keyCode === 13) {
      notifySearchTermChanged(searchTerm);
    }
  }

  handleSearchChanged = (event) => {
    const { notifySearchTermChanged, } = this.props;
    event.preventDefault();
    this.setState({searchTerm: event.target.value});
    if(event.target.value === '') {
      notifySearchTermChanged('');
    }
  }

  handleCloseFilter = (filter) => {
    const { filterTypes } = constants;
    const { notifyFiltersSelected } = this.props;
    const { selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill } = this.state;

    this.setState({ openSearchWin: false });
    switch(filter) {
      case filterTypes.DEPARTMENT:
        this.setState({showFilterDept: false, selectedDept: null});
        notifyFiltersSelected(null, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.EMAIL:
        this.setState({showFilterEmail: false, selectedEmail: null});
        notifyFiltersSelected(selectedDept, null, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.EMPLOYEE_ID:
        this.setState({showFilterEmployeeId: false, selectedEmployeeId: null});
        notifyFiltersSelected(selectedDept, selectedEmail, null, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.GROUP:
        this.setState({showFilterGroup: false, selectedGroup: null});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, null, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.JOB_TITLE:
        this.setState({showFilterJobTitle: false, selectedJobTitle: null});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, null, selectedSkill);
        break;
      case filterTypes.SKILL:
        this.setState({showFilterSkill: false, selectedSkill: null});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, null);
        break;
    }
    
  }

  handleAddFilterClick = (event) => {
    const { openFilterMenu, } = this.state;

    event.preventDefault();

    this.setState({openFilterMenu: !openFilterMenu});
  }

  handleSortOrderChanged = (event) => {
    const { ascending } = this.state;
    const { notifySortOrderChanged } = this.props;
    this.setState({ascending: !ascending});
    notifySortOrderChanged(!ascending);
  }

  handleRefreshClick = (event) => {
    const { notifyRefreshRequested } = this.props;
    event.preventDefault();
    notifyRefreshRequested();
    this.resetToDefaultState();
  }

  handleActionChange = (action) => {
    const { notifyDropDownOpened } = this.props;

    this.setState({openActionMenu: false, showConfirm: true, selectedAction: action});
    notifyDropDownOpened(false);
  }

  handleFilterChange = (filter) => {
    const { notifyDropDownOpened } = this.props;
    const { filterTypes } = constants;

    this.setState({openFilterMenu: false, openSearchWin: true, selectedFilter: filter});
    notifyDropDownOpened(false);
    switch(filter.name) {
      case filterTypes.DEPARTMENT:
        this.setState({showFilterDept: true});
        break;
      case filterTypes.EMAIL:
        this.setState({showFilterEmail: true});
        break;
      case filterTypes.EMPLOYEE_ID:
        this.setState({showFilterEmployeeId: true});
        break;
      case filterTypes.GROUP:
        this.setState({showFilterGroup: true});
        break;
      case filterTypes.JOB_TITLE:
        this.setState({showFilterJobTitle: true});
        break;
      case filterTypes.SKILL:
        this.setState({showFilterSkill: true});
        break;
    }
  }

  notifyConfirm = (request) => {
    const { selectedAction, } = this.state;
    const { notifyActionRequested, } = this.props;
    const { userActionTypes } = constants;

    this.setState({showConfirm: false});
    if(selectedAction.name === userActionTypes.REMOVE) {
      if(request) {
        this.setState({showConfirmStep2: true});
      }else {
        notifyActionRequested(request, selectedAction.name);
      }
    }else {
      notifyActionRequested(request, selectedAction.name);
    }
  }

  notifyConfirmStep2 = (confirmed) => {
    const { selectedAction } = this.state;
    const { notifyActionRequested } = this.props;
    this.setState({showConfirmStep2: false});
    if(confirmed) {
      notifyActionRequested(true, selectedAction.name);
    }else {
      notifyActionRequested(false, selectedAction.name);
    }
  }

  notifyConfirmOperation = (confirmed, groupName, groupDescription) => {
    const { notifyConfirmOperation } = this.props;
    
    this.setState({showConfirmOperation: false});
    notifyConfirmOperation(confirmed, groupName, groupDescription);
  }

  notifySearchDone = (filter) => {
    const { selectedFilter, selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill } = this.state;
    const { filterTypes, } = constants;
    const { notifyFiltersSelected, } = this.props;

    this.setState({openSearchWin: false});

    switch(selectedFilter.name) {
      case filterTypes.DEPARTMENT:
        this.setState({selectedDept: filter});
        notifyFiltersSelected(filter, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.EMAIL:
        this.setState({selectedEmail: filter});
        notifyFiltersSelected(selectedDept, filter, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.EMPLOYEE_ID:
        this.setState({selectedEmployeeId: filter});
        notifyFiltersSelected(selectedDept, selectedEmail, filter, selectedGroup, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.GROUP:
        this.setState({selectedGroup: filter});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, filter, selectedJobTitle, selectedSkill);
        break;
      case filterTypes.JOB_TITLE:
        this.setState({selectedJobTitle: filter});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, filter, selectedSkill);
        break;
      case filterTypes.SKILL:
        this.setState({selectedSkill: filter});
        notifyFiltersSelected(selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, filter);
        break;

    }
  }


  handleApproveClick = () => {
    const { userActionTypes } = constants;
    const approveText = (<FormattedMessage
      id="Header.approve"
      defaultMessage="Approve Users?"
    />);
    const action = { name: userActionTypes.APPROVE, body: approveText};
    this.setState({showConfirm: true, selectedAction: action});
  }

  handleDenyClick = () => {
    const { userActionTypes } = constants;
    const denyText = (<FormattedMessage
      id="Header.deny"
      defaultMessage="Deny Users?"
    />);
    const action = { name: userActionTypes.DENY, body: denyText};
    this.setState({showConfirm: true, selectedAction: action});
  }

  handleAddClick = () => {
    const { openOperationMenu, openActionMenu } = this.state;
    const { notifyDropDownOpened } = this.props;
    if(openActionMenu) {
      return;
    }
    this.setState({openOperationMenu: !openOperationMenu, addOperation: true});
    notifyDropDownOpened(!openOperationMenu);
  }

  handleRemoveClick = () => {
    const { openOperationMenu, openActionMenu } = this.state;
    const { notifyDropDownOpened, selectedType, notifyOperationRequested } = this.props;
    const { categoryTypes, operationTypes } = constants;
    if(openActionMenu) {
      return;
    }
    if(selectedType === categoryTypes.LOCATION) {
      this.setState({openOperationMenu: !openOperationMenu, addOperation: false});
      notifyDropDownOpened(!openOperationMenu);
    }else {
      const removeUsersFromDept = { name: operationTypes.REMOVE_USERS_FROM_DEPT, body: text.department};
      const removeUsersFromGroup = { name: operationTypes.REMOVE_USERS_FROM_GROUP, body: text.group};
      const removeUsersFromSkills = { name: operationTypes.REMOVE_USERS_FROM_SKILL, body: text.skills};
      let selectedOperation = null;
      if(selectedType === categoryTypes.DEPARTMENTS) {
        selectedOperation = removeUsersFromDept;
      }else if(selectedType === categoryTypes.GROUPS) {
        selectedOperation = removeUsersFromGroup;
      }else if(selectedType === categoryTypes.SKILLS) {
        selectedOperation = removeUsersFromSkills;
      }
      notifyOperationRequested(selectedOperation);
    }
  }

  handleOpenMenuClick = () => {
    const { openActionMenu, openOperationMenu } = this.state;
    const { notifyDropDownOpened } = this.props;
    if(openOperationMenu) {
      return;
    }
    this.setState({openActionMenu: !openActionMenu, addOperation: false});
    notifyDropDownOpened(!openActionMenu);
  }

  handleOperationChange = (operation) => {
    const { notifyOperationRequested, notifyDropDownOpened } = this.props;
    this.setState({openOperationMenu: false});
    notifyOperationRequested(operation);
    notifyDropDownOpened(false);
  }

  handleSortDropdownClick = () => {
    const { openSortMenu } = this.state;
    const { notifyDropDownOpened } = this.props;

    this.setState({openSortMenu: !openSortMenu});
    notifyDropDownOpened(!openSortMenu);
  }

  handleSortChange = (sort) => {
    const { notifySortTypeChanged, notifyDropDownOpened } = this.props;

    this.setState({openSortMenu: false, selectedSort: sort});
    notifySortTypeChanged(sort);
    notifyDropDownOpened(false);
  }


  renderUserActionItems = () => {
    const { actionMenuPos, } = this.state;
    const { userActionTypes } = constants;

    const promote = { name: userActionTypes.PROMOTE, body: text.grantAminPriv};
    const withdraw = { name: userActionTypes.WITHDRAW, body: text.withdrawAdminPriv};
    const remove = { name: userActionTypes.REMOVE, body: text.removeFromLocation};
    const items = [promote, withdraw, remove];
    
    const actionItems = items.map((item, index) => (
      <div 
        key={index} 
        className="toolbar__dropdown-item-wrap" 
        value={item}
        onClick={(event) => {this.handleActionChange(item)}}
      >
        <label className="toolbar__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if(actionMenuPos) {
      return (
        <styled.WinContainer  ref={this.actionRef} top={actionMenuPos.top} left={actionMenuPos.left} width={actionMenuPos.width} height={actionMenuPos.height}>
          {actionItems}
        </styled.WinContainer>
      );
    }
  }

  renderFilterMenu = () => {
    const { dropdownPos  } = this.state;
    const { locationSettings, } = this.props;
    const { filterTypes, } = constants;

    const itemDept = { name: filterTypes.DEPARTMENT, body: text.department};
    const itemEmail = { name: filterTypes.EMAIL, body: text.email};
    const itemEmployeeId = { name: filterTypes.EMPLOYEE_ID, body: text.employeeID};
    const itemGroup = { name: filterTypes.GROUP, body: text.group};
    const itemJobTitle = { name: filterTypes.JOB_TITLE, body: text.jobTitle};
    const itemSkill = { name: filterTypes.SKILL, body: text.skill};

    let items = [];
    
    if(locationSettings && locationSettings.cfg__departments === 1) {
      items.push(itemDept);
    }

    items.push(itemEmail);

    if(locationSettings && locationSettings.cfg__badge_id === 1) {
        items.push(itemEmployeeId);
    }

    items.push(itemGroup);
    items.push(itemJobTitle);

    if(locationSettings && locationSettings.cfg__skill === 1) {
        items.push(itemSkill);
    }
   
    const filterItems = items.map((item, index) => (
      <div 
        key={index} 
        className="toolbar__dropdown-item-wrap" 
        value={item}
        onClick={(event) => {this.handleFilterChange(item)}}
      >
        <label className="toolbar__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if(dropdownPos) {
      return (
        <styled.WinContainer ref={this.filterWinRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {filterItems}
        </styled.WinContainer>
      );
    }

  }

  renderOperationItems = () => {
    const { locationSettings, } = this.props;
    const { addOperation,  dropdownPos, } = this.state;
    const { operationTypes, } = constants;
   
    const assignUsersToDept = { name: operationTypes.ASSIGN_USERS_TO_DEPT, body: text.department};
    const assignUsersToGroup = { name: operationTypes.ASSIGN_USERS_TO_GROUP, body: text.group};
    const assignUsersToSkill = { name: operationTypes.ASSIGN_USERS_TO_SKILL, body: text.skills};
    const removeUsersFromDept = { name: operationTypes.REMOVE_USERS_FROM_DEPT, body: text.department};
    const removeUsersFromGroup = { name: operationTypes.REMOVE_USERS_FROM_GROUP, body: text.group};
    const removeUsersFromSkills = { name: operationTypes.REMOVE_USERS_FROM_SKILL, body: text.skills};

    let addItems = [assignUsersToDept, assignUsersToGroup, assignUsersToSkill];
    let removeItems = [removeUsersFromDept, removeUsersFromGroup, removeUsersFromSkills];
    if(locationSettings && locationSettings.cfg__departments !== 1) {
      addItems = [assignUsersToGroup, assignUsersToSkill];
      removeItems = [removeUsersFromGroup, removeUsersFromSkills];
    }
    if(locationSettings && locationSettings.cfg__skill !== 1) {
      addItems = [assignUsersToDept, assignUsersToGroup];
      removeItems = [removeUsersFromDept, removeUsersFromGroup];
    }
    if(locationSettings && locationSettings.cfg__departments !== 1 && locationSettings.cfg__skill !== 1) {
      addItems = [assignUsersToGroup];
      removeItems = [removeUsersFromGroup];
    }
    
    const items = addOperation ? addItems : removeItems;
    
    const operationItems = items.map((item, index) => (
      <div 
        key={index} 
        className="category__dropdown-item-wrap" 
        value={item}
        onClick={(event) => {this.handleOperationChange(item)}}
      >
        <label className="category__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if(dropdownPos) {
      return (
        <styled.WinContainer ref={this.operationRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {operationItems}
        </styled.WinContainer>
      );
    }
  }

  renderSortMenu = () => {
    const {dropdownPos, } = this.state;
    const { sortTypes, } = constants;

    const name = (<FormattedMessage id="Header.name" defaultMessage="Name" />);
    const jobTitle = (<FormattedMessage id="Header.jobTitle" defaultMessage="Job Title" />);
    const userRole = (<FormattedMessage id="Header.userAccess" defaultMessage="User Access" />);
    const itemName = {name: sortTypes.FIRST_NAME, body: name};
    const itemJobTitle = { name: sortTypes.POSITION, body: jobTitle};
    const itemUserRole = {name: sortTypes.USER_ROLE, body: userRole};

    //const items = [itemJobTitle, itemName, itemStatus, itemUserRole];
    const items = [itemJobTitle, itemName, itemUserRole];
    const sortItems = items.map((item, index) => (
      <div 
        key={index} 
        className="toolbar__dropdown-item-wrap" 
        value={item}
        onClick={(event) => {this.handleSortChange(item)}}
      >
        <label className="toolbar__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if(dropdownPos) {
      return (
        <styled.WinContainer ref={this.sortWinRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {sortItems}
        </styled.WinContainer>
      );
    }

  }

  shouldShowFilterButton = () => {
    const { locationSettings } = this.props;
    const {
      showFilterDept,
      showFilterEmail,
      showFilterEmployeeId,
      showFilterGroup,
      showFilterJobTitle,
      showFilterSkill,
    } = this.state;

    const cfg = locationSettings || {};
    const filters = [];

    if (cfg.cfg__departments === 1) filters.push(showFilterDept);
    filters.push(showFilterEmail);
    if (cfg.cfg__badge_id === 1) filters.push(showFilterEmployeeId);
    filters.push(showFilterGroup, showFilterJobTitle);
    if (cfg.cfg__skill === 1) filters.push(showFilterSkill);

    return filters.some((f) => !f);
  };


  render() {
  const {
    searchTerm, openActionMenu, showConfirm, showConfirmOperation,
    showConfirmStep2, selectedAction, openOperationMenu, openSortMenu, selectedSort, ascending,
    openFilterMenu, showFilterDept, showFilterEmail, showFilterEmployeeId, showFilterGroup, showFilterJobTitle, showFilterSkill,
    openSearchWin, dropdownPos, selectedFilter, selectedDept, selectedEmail, selectedEmployeeId, selectedGroup, selectedJobTitle, selectedSkill,
  } = this.state;
  const {
    selectedType, selectedItem, filteredUsers, 
    selectedUsers, requestedOperation, channels, channelData, departments, skills, intl,
  } = this.props;
  const { filterTypes } = constants;

  const usersOnTable = filteredUsers ? filteredUsers.length : 0;
  const selectedPendingUsers = selectedUsers.length > 0 ? selectedUsers.filter((user) => user.status === 'pending') : [];
  const selectedActiveUsers = selectedUsers.length > 0 ? selectedUsers.filter((user) => user.status === 'active') : [];
  const sortButtonClassName = openSortMenu ? "toolbar__sort-arrow-button-up" : "toolbar__sort-arrow-button-down";
  const sortOrderButtonClassName =  ascending ? 'toolbar__sort-order-descending' : 'toolbar__sort-order-ascending';
  const sortBoxText = selectedSort ? selectedSort.body : text.userRoleText;

  // Helper for rendering modal overlays
  const renderModal = (condition, content) => condition ? <Modal>{content}</Modal> : null;

  // All selected users are pending users
  if (selectedPendingUsers.length > 0 && selectedUsers.length === selectedPendingUsers.length) {
    return (
      <div className="toolbar__top-wrap">
        <div className="toolbar__wrap">
          <div className="toolbar__row-2">
            <div className="toolbar__button-group-1-wrap">
              <button className="toolbar__approve-users" onClick={this.handleApproveClick}>
                {text.approveUsers(selectedPendingUsers.length)}
              </button>
              <button className="toolbar__deny-users" onClick={this.handleDenyClick}>
                {text.denyUsers(selectedPendingUsers.length)}
              </button>
            </div>
            <div className="toolbar__sort-drop-down" ref={this.sortRef} onClick={this.handleSortDropdownClick}>
              {text.sortBy}
              <label className="toolbar__sort-item-text">{sortBoxText}</label>
              <button className={sortButtonClassName} />
            </div>
            <button className={sortOrderButtonClassName} onClick={this.handleSortOrderChanged} />
            <button className="toolbar__refresh-button" onClick={this.handleRefreshClick} />
          </div>
        </div>
        {renderModal(openSortMenu, this.renderSortMenu())}
        {renderModal(showConfirm, (
          <Confirm
            selectedAction={selectedAction}
            notifyConfirm={this.notifyConfirm}
            selectedUsers={selectedUsers}
          />
        ))}
        <styled.Overlay display={showConfirm ? 'block' : 'none'} />
      </div>
    );
  }

  // All selected users are active users or operation requested
  if (
    (selectedActiveUsers.length > 0 && selectedUsers.length === selectedActiveUsers.length)
    || (requestedOperation && requestedOperation.length > 0)
  ) {
    return (
      <div className="toolbar__top-wrap">
        <div className="toolbar__wrap">
          <div className="toolbar__row-2">
            <div className="toolbar__button-group-1-wrap">
              <button className="toolbar__add-users" ref={this.addRef} onClick={this.handleAddClick}>{text.add}</button>
              <button className="toolbar__remove-users" ref={this.removeRef} onClick={this.handleRemoveClick}>{text.remove}</button>
            </div>
            <button className="toolbar__open-more" onClick={this.handleOpenMenuClick} ref={this.openRef} />
            <div className="toolbar__sort-drop-down" ref={this.sortRef} onClick={this.handleSortDropdownClick}>
              {text.sortBy}
              <label className="toolbar__sort-item-text">{sortBoxText}</label>
              <button className={sortButtonClassName} />
            </div>
            <button className={sortOrderButtonClassName} onClick={this.handleSortOrderChanged} />
            <button className="toolbar__refresh-button" onClick={this.handleRefreshClick} />
          </div>
        </div>
        {renderModal(openActionMenu, this.renderUserActionItems())}
        {renderModal(openOperationMenu, this.renderOperationItems())}
        {renderModal(openSortMenu, this.renderSortMenu())}
        {renderModal(openFilterMenu, this.renderFilterMenu())}
        {renderModal(showConfirm, (
          <Confirm
            selectedAction={selectedAction}
            notifyConfirm={this.notifyConfirm}
            selectedUsers={selectedUsers}
          />
        ))}
        {renderModal(showConfirmStep2, (
          <ConfirmStep2
            selectedAction={selectedAction}
            notifyConfirmStep2={this.notifyConfirmStep2}
            selectedUsers={selectedUsers}
          />
        ))}
        {renderModal(showConfirmOperation, (
          <ConfirmOperation
            requestedOperation={requestedOperation}
            channels={channels}
            channelData={channelData}
            selectedUsers={selectedUsers}
            departments={departments}
            skills={skills}
            notifyConfirmOperation={this.notifyConfirmOperation}
            selectedItem={selectedItem}
            selectedType={selectedType}
          />
        ))}
        <styled.Overlay display={showConfirm || showConfirmOperation ? 'block' : 'none'} />
      </div>
    );
  }

  // Default toolbar
  return (
    <div className="toolbar__top-wrap">
      <div className="toolbar__wrap">
        <div className="toolbar__row-2">
          <input
            className="toolbar__search-box"
            onChange={this.handleSearchChanged}
            onKeyUp={this.handleKeyPress}
            type="text"
            placeholder={intl.formatMessage(this.messages.placeholder)}
            value={searchTerm}
          />
          <div className="toolbar__filter-wrap">
            {showFilterDept && (
              <div className="toolbar__filter" ref={this.deptRef} onClick={() => this.handleCloseFilter(filterTypes.DEPARTMENT)}>
                <p className="toolbar__filter-text">{text.deptIs}</p>
                <p className="toolbar__item-name">{selectedDept ? selectedDept.name : ''}</p>
              </div>
            )}
            {showFilterEmail && (
              <div className="toolbar__filter" ref={this.emailRef} onClick={() => this.handleCloseFilter(filterTypes.EMAIL)}>
                <p className="toolbar__filter-text">{text.emailIs}</p>
                <p className="toolbar__item-name">{selectedEmail ? selectedEmail : ''}</p>
              </div>
            )}
            {showFilterEmployeeId && (
              <div className="toolbar__filter" ref={this.employeeIdRef} onClick={() => this.handleCloseFilter(filterTypes.EMPLOYEE_ID)}>
                <p className="toolbar__filter-text">{text.employeeIdIs}</p>
                <p className="toolbar__item-name">{selectedEmployeeId ? selectedEmployeeId : ''}</p>
              </div>
            )}
            {showFilterGroup && (
              <div className="toolbar__filter" ref={this.groupRef} onClick={() => this.handleCloseFilter(filterTypes.GROUP)}>
                <p className="toolbar__filter-text">{text.groupIs}</p>
                <p className="toolbar__item-name">{selectedGroup ? selectedGroup.channel_name : ''}</p>
              </div>
            )}
            {showFilterJobTitle && (
              <div className="toolbar__filter" ref={this.jobTitleRef} onClick={() => this.handleCloseFilter(filterTypes.JOB_TITLE)}>
                <p className="toolbar__filter-text">{text.jobTitleIs}</p>
                <p className="toolbar__item-name">{selectedJobTitle ? selectedJobTitle : ''}</p>
              </div>
            )}
            {showFilterSkill && (
              <div className="toolbar__filter" ref={this.skillRef} onClick={() => this.handleCloseFilter(filterTypes.SKILL)}>
                <p className="toolbar__filter-text">{text.skillIs}</p>
                <p className="toolbar__item-name">{selectedSkill ? selectedSkill.skill_content : ''}</p>
              </div>
            )}
          </div>
          {this.shouldShowFilterButton() && (
            <button className="toolbar__add-filters" ref={this.filterRef} onClick={this.handleAddFilterClick}>
              {text.addFilters}
            </button>
          )}
          <div className='flex-row'>
            <label className="toolbar__results-text semibold-14">{text.results(usersOnTable)}</label>
            <div className="toolbar__sort-drop-down" ref={this.sortRef} onClick={this.handleSortDropdownClick}>
              {text.sortBy}
              <label className="toolbar__sort-item-text">{sortBoxText}</label>
              <button className={sortButtonClassName} />
            </div>
            <button className={sortOrderButtonClassName} onClick={this.handleSortOrderChanged} />
            <button className="toolbar__refresh-button" onClick={this.handleRefreshClick} />
          </div>
        </div>
      </div>
      {renderModal(openSortMenu, this.renderSortMenu())}
      {renderModal(openFilterMenu, this.renderFilterMenu())}
      {renderModal(openSearchWin, (
        <SearchDialogue
          departments={departments}
          channels={channels}
          skills={skills}
          notifySearchDone={this.notifySearchDone}
          position={dropdownPos}
          selectedFilter={selectedFilter}
        />
      ))}
    </div>
  );
}
}

Header.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired
};

export default injectIntl(Header);

